/**
 * sueco-shipping-info-modal: 商品ページ「配送・送料について」セクションを
 * ボタン化 → クリックでオーバーレイモーダルで表示する。
 *
 * 商品 description 内の `.sueco-shipping-info` 要素を検出し、
 * 元の内容を保持しつつボタンに置き換える。JS 無効時は CSS フォールバックで現状表示。
 *
 * 2026-05-27 追加
 */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var infos = document.querySelectorAll('.sueco-shipping-info');
    if (!infos.length) return;

    infos.forEach(function (info) {
      if (info.dataset.suecoShippingModalReady === '1') return;
      info.dataset.suecoShippingModalReady = '1';

      // 元の内容 (HTML) を保持して、ボタンに置き換える
      var originalHtml = info.innerHTML;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sueco-shipping-info__open-btn';
      btn.textContent = '配送・送料表を見る';

      info.innerHTML = '';
      info.appendChild(btn);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(originalHtml);
      });
    });
  }

  var openOverlay = null;

  function openModal(innerHtml) {
    closeOpen();

    var overlay = document.createElement('div');
    overlay.className = 'sueco-shipping-modal__overlay';
    overlay.setAttribute('role', 'presentation');

    var dialog = document.createElement('div');
    dialog.className = 'sueco-shipping-modal';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', '配送・送料について');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'sueco-shipping-modal__close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = '&times;';

    var body = document.createElement('div');
    body.className = 'sueco-shipping-modal__body';
    body.innerHTML = innerHtml;

    // 商品ごとに整形: サイズバッジ + 対象列フィルタ + 複数購入ステップ化
    try {
      // 優先順位: description 内の隠し「送料区分」 > モーダル body 内 (snippet 出力)
      var sizes = parseShippingSizeFromDescription() || parseShippingSize(body);
      insertSizeBadge(body, sizes);
      applyShippingSize(body, sizes);
      replaceMultiPurchaseText(body, sizes);
    } catch (err) {
      console.warn('[sueco-shipping] format error:', err);
    }

    dialog.appendChild(closeBtn);
    dialog.appendChild(body);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    // スクロール固定
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    function close() {
      if (openOverlay !== overlay) return;
      overlay.remove();
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
      openOverlay = null;
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    openOverlay = overlay;
    // フォーカスを close ボタンへ
    setTimeout(function () { closeBtn.focus(); }, 0);
  }

  function closeOpen() {
    if (openOverlay && openOverlay.parentNode) {
      openOverlay.parentNode.removeChild(openOverlay);
      document.body.style.overflow = '';
      openOverlay = null;
    }
  }

  // ───────────────────────────────────────────
  // 商品 description の送料セクション整形
  // ───────────────────────────────────────────

  // 商品 description 内 (hidden だが DOM にある) の送料区分を優先取得
  function parseShippingSizeFromDescription() {
    var descInfos = document.querySelectorAll('.product__description .sueco-shipping-info');
    for (var i = 0; i < descInfos.length; i++) {
      var s = parseShippingSize(descInfos[i]);
      if (s.has60 || s.has80) return s;
    }
    return null;
  }

  // モーダル冒頭にサイズバッジを挿入
  function insertSizeBadge(body, sizes) {
    if (!sizes || (!sizes.has60 && !sizes.has80)) return;
    var h3 = body.querySelector('h3');
    if (!h3) return;
    var label, cls;
    if (sizes.has60 && sizes.has80) {
      label = 'ご注文個数により <strong>60 / 80 サイズ</strong>';
      cls = 'both';
    } else if (sizes.has60) {
      label = 'この商品は <strong>60サイズ</strong> で発送します';
      cls = '60';
    } else {
      label = 'この商品は <strong>80サイズ</strong> で発送します';
      cls = '80';
    }
    var badge = document.createElement('div');
    badge.className = 'sueco-shipping-modal__badge sueco-shipping-modal__badge--' + cls;
    badge.innerHTML = label;
    h3.parentNode.insertBefore(badge, h3.nextSibling);
  }

  // 「この商品の送料区分: 20個は60サイズ、40個以上は80サイズ」等から
  // 60/80 サイズの適用有無を判定
  function parseShippingSize(container) {
    var result = { has60: false, has80: false, raw: '' };
    var ps = container.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var text = ps[i].textContent || '';
      if (text.indexOf('送料区分') === -1) continue;
      result.raw = text;
      result.has60 = /60\s*サイズ/.test(text);
      result.has80 = /80\s*サイズ/.test(text);
      break;
    }
    // 文言になければテーブルの thead から逆算 (60/80サイズ列が両方ある = デフォルト両方)
    if (!result.has60 && !result.has80) {
      var ths = container.querySelectorAll('table.sueco-shipping-table thead th');
      ths.forEach(function (th) {
        var t = th.textContent || '';
        if (/60\s*サイズ/.test(t)) result.has60 = true;
        if (/80\s*サイズ/.test(t)) result.has80 = true;
      });
    }
    return result;
  }

  // 対象外サイズ列を完全に削除 (DOM から remove)
  function applyShippingSize(container, sizes) {
    // 両方有効 or 両方なしの場合は何もしない (egg の variants ケース等)
    if (sizes.has60 && sizes.has80) return;
    if (!sizes.has60 && !sizes.has80) return;

    var hideLabel = sizes.has60 ? '80サイズ' : '60サイズ';

    container.querySelectorAll('table.sueco-shipping-table').forEach(function (table) {
      // thead から対象列のインデックスを特定
      var headers = table.querySelectorAll('thead th');
      var targetIdx = -1;
      headers.forEach(function (th, idx) {
        if ((th.textContent || '').indexOf(hideLabel) !== -1) targetIdx = idx;
      });
      if (targetIdx < 0) return;

      // 各行の対応する th/td を削除
      table.querySelectorAll('tr').forEach(function (row) {
        var cells = row.querySelectorAll('th, td');
        if (cells[targetIdx]) cells[targetIdx].parentNode.removeChild(cells[targetIdx]);
      });
    });
  }

  // 「複数購入時は...」長文をステップ表に置換
  function replaceMultiPurchaseText(container, sizes) {
    var ps = container.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      var text = p.textContent || '';
      if (text.indexOf('複数購入') === -1) continue;
      if (text.length < 60) continue;

      var stepHtml = buildStepCard(sizes);
      var wrap = document.createElement('div');
      wrap.innerHTML = stepHtml;
      var newEl = wrap.firstElementChild;
      if (newEl && p.parentNode) {
        p.parentNode.replaceChild(newEl, p);
      }
      break;
    }
  }

  function buildStepCard(sizes) {
    var mixNote = '';
    if (sizes.has60 && sizes.has80) {
      mixNote = '<p class="sueco-shipping-steps__note">※60サイズと80サイズを一緒に購入する場合は、すべて80サイズ送料で計算されます。</p>';
    }
    return [
      '<div class="sueco-shipping-steps">',
        '<h4 class="sueco-shipping-steps__title">複数購入時の送料ルール</h4>',
        '<ol class="sueco-shipping-steps__list">',
          '<li><span class="sueco-shipping-steps__num">1〜2点</span><span class="sueco-shipping-steps__txt">表の通常送料</span></li>',
          '<li><span class="sueco-shipping-steps__num">3点目</span><span class="sueco-shipping-steps__txt">+200円</span></li>',
          '<li><span class="sueco-shipping-steps__num">4点目以降</span><span class="sueco-shipping-steps__txt">1点追加ごとに+200円</span></li>',
        '</ol>',
        mixNote,
      '</div>'
    ].join('');
  }
})();
